import { ShiftsView } from '@/domains/shifts/components/ShiftsView';
import {
  SHIFTS_PAGE_SIZE,
  SHIFT_LIST_DEFAULTS,
} from '@/domains/shifts/constants/shiftListDefaults';
import { useCreateShift, useDeleteShift, useShifts } from '@/domains/shifts/hooks/useShifts';
import { useUrlFilters } from '@/shared/hooks/useUrlFilters';
import { useNavigate } from 'react-router';

export function ShiftsPage() {
  const navigate = useNavigate();
  const [filters, setFilters] = useUrlFilters(SHIFT_LIST_DEFAULTS);

  const page = Math.max(1, parseInt(filters.page, 10) || 1);
  const searchTerm = filters.search;

  const { data, isLoading, isFetching, isError } = useShifts({
    limit: SHIFTS_PAGE_SIZE,
    skip: (page - 1) * SHIFTS_PAGE_SIZE,
    ...(searchTerm !== '' && { search: searchTerm }),
  });
  const createShift = useCreateShift();
  const deleteShift = useDeleteShift();

  return (
    <ShiftsView
      shifts={data?.values ?? []}
      totalCount={data?.count ?? 0}
      page={page}
      pageSize={SHIFTS_PAGE_SIZE}
      search={searchTerm}
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      onSearchChange={(search) => setFilters({ search, page: '1' })}
      onPageChange={(p) => setFilters({ page: String(p) })}
      onShiftClick={(shiftId) => navigate(`/shifts/${shiftId}`)}
      onCreateShift={async (input) => {
        await createShift.mutateAsync(input);
      }}
      onDeleteShift={async (id) => {
        await deleteShift.mutateAsync(id);
      }}
    />
  );
}
